import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "header-padding" }, "Devices", -1)
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = { class: "p-inputgroup" }

import { MdmDeviceSchema, MdmPolicySchema } from '@/generated/sdk'
import { format } from 'date-fns'
import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'DevicesPage',
  setup(__props) {

const store = useStore()
const router = useRouter()

const policyFilter = ref<string>(null)
const expectedPolicyFilter = ref<string>(null)
const filter = ref<string>('')
const filterFieldOptions = ref<string[]>(['IMEI', 'Serial'])
const filterField = ref<string>(filterFieldOptions.value[0])
const page = ref<number>(1)
const size = ref<number>(10)

const totalRecords = computed<number>(() => store.state.app.stats.countMdmDevice)
const mdmPolicies = computed<MdmPolicySchema[]>(() => store.state.policies.mdmPolicies)
const mdmDevices = computed<MdmDeviceSchema[]>(() => store.state.devices.mdmDevices)

watch([policyFilter, expectedPolicyFilter, filter, filterField], () => {
  loadMdmDevices()
})

onMounted(async () => {
  await loadMdmDevices()
})

async function loadMdmDevices(): Promise<void> {
  const val = filter.value.trim() || undefined
  await store.dispatch('loadMdmDevices', {
    input: {
      imei: filterField.value === 'IMEI' ? val : undefined,
      serial: filterField.value !== 'IMEI' ? val : undefined,
      policyName: formatId(policyFilter.value) || undefined, // Hacky way to match only on id
      expectedPolicyName: formatId(expectedPolicyFilter.value) || undefined, // Hacky way to match only on id
      enterpriseId: store.state.app.enterprise.id,
    },
    queryArgs: {
      page: page.value,
      size: val ? size.value + 10 : size.value, // Hacky way to get all results,
    },
  })
}

async function updateMdmDevicePolicy(e: MdmDeviceSchema): Promise<void> {
  const confirmMessage = `Update device with IMEI: ${e.imei} to "${formatPolicyName(e.policyName)}"?`
  if (window.confirm(confirmMessage)) {
    await store.dispatch('updateMdmDevices', [
      {
        id: e.id,
        googleId: e.googleId,
        policyName: e.policyName,
      } as MdmDeviceSchema,
    ])
  }
}

async function deleteDevice(e: MdmDeviceSchema): Promise<void> {
  if (window.confirm(`WARNING: Do you want to delete device with IMEI: ${e.imei}?`)) {
    await store.dispatch('deleteMdmDevice', e)
  }
}

function formatId(id: string): string {
  return id?.split('/')[3]
}

function formatPolicyName(id: string): string {
  return mdmPolicies.value.find(m => m.googleId === id)?.name
}

function formatDate(date: string): string {
  return date ? format(new Date(date), 'dd-MM-yy HH:mm:ss') : undefined
}

async function onPage(event): Promise<void> {
  page.value = event.page + 1
  size.value = event.rows
  await loadMdmDevices()
}

function rowClick(event) {
  router.push(`/devices/${event.data.id}`)
}

return (_ctx: any,_cache: any) => {
  const _component_DodoIcon = _resolveComponent("DodoIcon")!
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_PrimeDropdown = _resolveComponent("PrimeDropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DodoColumn = _resolveComponent("DodoColumn")!

  return (_openBlock(), _createBlock(_component_DodoColumn, null, {
    default: _withCtx(() => [
      _createVNode(_component_DodoRow, { justify: "between" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_DodoButton, {
            color: "success",
            variant: "solid",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/policies/bulk')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DodoIcon, { name: "list_alt_add" }),
              _createTextVNode(" Bulk upload ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (mdmDevices.value)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            lazy: true,
            "total-records": totalRecords.value,
            value: mdmDevices.value,
            "data-key": "id",
            "responsive-layout": "scroll",
            paginator: true,
            rows: 10,
            "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
            "rows-per-page-options": [10, 100, 1000],
            "current-page-report-template": "Showing {first} to {last} of {totalRecords}",
            "filter-display": "menu",
            "selection-mode": "single",
            onPage: _cache[6] || (_cache[6] = ($event: any) => (onPage($event))),
            onRowClick: _cache[7] || (_cache[7] = ($event: any) => (rowClick($event)))
          }, {
            header: _withCtx(() => [
              _createVNode(_component_DodoRow, { justify: "between" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DodoRow, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_PrimeDropdown, {
                        modelValue: policyFilter.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((policyFilter).value = $event)),
                        options: mdmPolicies.value,
                        loading: mdmPolicies.value == null,
                        "show-clear": policyFilter.value !== null,
                        "option-value": "googleId",
                        "option-label": "name",
                        placeholder: "Filter by policy"
                      }, null, 8, ["modelValue", "options", "loading", "show-clear"]),
                      _createVNode(_component_PrimeDropdown, {
                        modelValue: expectedPolicyFilter.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((expectedPolicyFilter).value = $event)),
                        options: mdmPolicies.value,
                        loading: mdmPolicies.value == null,
                        "show-clear": expectedPolicyFilter.value !== null,
                        "option-value": "googleId",
                        "option-label": "name",
                        placeholder: "Filter by expected policy"
                      }, null, 8, ["modelValue", "options", "loading", "show-clear"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DodoRow, null, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, [
                        _hoisted_3,
                        _createVNode(_component_InputText, {
                          modelValue: filter.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filter).value = $event)),
                          placeholder: `Search`
                        }, null, 8, ["modelValue"])
                      ]),
                      _createVNode(_component_PrimeDropdown, {
                        modelValue: filterField.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterField).value = $event)),
                        options: filterFieldOptions.value
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_PrimeColumn, {
                field: "id",
                header: "ID"
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(formatId(data.googleId) || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeColumn, {
                field: "lastPolicySyncTime",
                header: "Last policy sync time"
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(formatDate(data.lastPolicySyncTime) || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeColumn, {
                field: "serial",
                header: "Serial number"
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(data.serial || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeColumn, {
                field: "imei",
                header: "IMEI"
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(data.imei || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeColumn, {
                field: "policyName",
                header: "Policy"
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_PrimeDropdown, {
                      modelValue: data.policyName,
                      "onUpdate:modelValue": ($event: any) => ((data.policyName) = $event),
                      class: "mdm-margin-right-s",
                      options: mdmPolicies.value,
                      loading: mdmPolicies.value == null,
                      "option-value": "googleId",
                      "option-label": "name",
                      placeholder: "Select a policy",
                      disabled: !data.googleId,
                      onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent","stop"]))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "loading", "disabled"]),
                    _createVNode(_component_DodoButton, {
                      variant: "solid",
                      class: "mdm-margin-right-s",
                      disabled: !data.googleId,
                      square: "",
                      color: "info",
                      onClick: _withModifiers(($event: any) => (updateMdmDevicePolicy(data)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DodoIcon, {
                          name: "checkmark",
                          fill: ""
                        })
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]),
                    _createVNode(_component_DodoButton, {
                      variant: "solid",
                      square: "",
                      color: "danger",
                      onClick: _withModifiers(($event: any) => (deleteDevice(data)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DodoIcon, {
                          name: "delete",
                          fill: ""
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeColumn, {
                field: "expectedPolicyName",
                header: "Expected policy"
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(formatPolicyName(data.expectedPolicyName) || '-'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["total-records", "value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})